import { FC } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { DashboardUtils } from '@/features/dashboard/utils/dashboardUtils';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import DashboardManagedByChartSkeleton from '@/features/dashboard/components/DashboardManagedBy/DashboardManagedByChartSkeleton';

type Props = {};

const DashboardManagedByBlockSkeleton: FC<Props> = () => {
	const { t } = useTranslation();

	const {
		icon: Icon,
		iconClasses,
		iconBgClasses,
	} = DashboardUtils.getAllChartsConfig('managedBy');

	return (
		<div className='p-6 flex grow  flex-col gap-6 border border-popover-100 rounded-2.5xl bg-popover-10 select-none'>
			<div className='flex items-center gap-4'>
				<div
					className={cn(
						'size-8 flex items-center justify-center rounded-semi-xl',
						iconBgClasses,
					)}>
					<Icon className={iconClasses} />
				</div>
				<h4 className='text-xl font-medium'>{t('Managed by')}</h4>
			</div>
			<div className='grow-1 flex flex-col items-center justify-center gap-1'>
				<DashboardManagedByChartSkeleton />
			</div>
			<Skeleton className='h-11 w-full rounded-full' />
		</div>
	);
};

export default DashboardManagedByBlockSkeleton;
